<div class="page form-page">
  <a backButton
     class="back-link">
    <i class="fas fa-chevron-left"></i>
    {{ 'store.vouchers.title' | translate }}
  </a>
  <div class="form-title">
   {{ (editMode ? 'store.vouchers.form.editTitle' : 'store.vouchers.form.createTitle') | translate }}
  </div>
  <div class="form-main-container">
    <div class="details-container">
      <div class="sub-title">{{ 'common.details' | translate }}</div>
      <div class="two-input-container">
        <div class="label-container">{{ 'store.vouchers.form.name' | translate }}</div>
        <div class="label-container quantity-con">{{ 'store.vouchers.form.quantity' | translate }}
          <button *ngIf="editMode" (click)="openGenerate(template)">
          <img src="assets/images/add-circle.png" alt="">
          {{ 'store.vouchers.form.generateMore' | translate }}
        </button>
        </div>
        <div class="input-container">
          <input [(ngModel)]="voucher.title" type="text" [placeholder]="'store.vouchers.form.namePlaceholder' | translate">
          <div *ngIf="isSubmitted && !voucher.title?.toString()?.trim()" class="error">{{ 'store.vouchers.form.nameRequired' | translate }}</div>
        </div>
        <div class="input-container">
          <input [disabled]="editMode" oninput="validity.valid||(value='');" [(ngModel)]="voucher.codesCount" type="number" min="0" placeholder="100">
          <div *ngIf="isSubmitted && !voucher.codesCount?.toString()?.trim()" class="error">{{ 'store.vouchers.form.quantityRequired' | translate }}</div>
        </div>

        <div class="label-container">{{ 'store.vouchers.form.value' | translate }}</div>
        <div class="label-container">{{ 'store.vouchers.form.price' | translate }}</div>
        <div class="input-container">
          <input [(ngModel)]="voucher.voucherValue" oninput="validity.valid||(value='');" min="0" type="number" placeholder="0.00">
          <div *ngIf="isSubmitted && !voucher.voucherValue?.toString()?.trim()" class="error">{{ 'store.vouchers.form.priceRequired' | translate }}</div>
        </div>
        <div class="input-container">
          <input [(ngModel)]="voucher.price" min="0" oninput="validity.valid||(value='');" type="number" placeholder="0.00">
          <div *ngIf="isSubmitted && !voucher.price?.toString()?.trim()" class="error">{{ 'store.vouchers.form.valueRequired' | translate }}</div>
        </div>
      </div>
      <div class="label-container">{{ 'common.description' | translate }}</div>
      <textarea [(ngModel)]="voucher.description" [placeholder]="'store.vouchers.form.descriptionPlaceholder' | translate" class="description-textarea">

      </textarea>
      <div *ngIf="isSubmitted && !voucher.description" class="error">{{ 'store.vouchers.form.descriptionRequired' | translate }}</div>
    </div>
    <div>
      <div class="visibility-container">
        <div class="text">{{ 'store.vouchers.form.visibility' | translate }} :</div>
        <div style="display: inline-flex;">
          <label class="container">
            <input [value]="true" [(ngModel)]="voucher.isVisible" type="radio"  [name]="'visibility'">
            <span class="checkmark"></span>
            <div class="checkbox-text">{{ 'common.active' | translate }}</div>
          </label>
          <label class="container">
            <input [value]="false" [disabled]="!editMode" [(ngModel)]="voucher.isVisible"  type="radio"  [name]="'visibility'">
            <span class="checkmark"></span>
            <div class="checkbox-text">{{ 'common.inactive' | translate }}</div>
          </label>
        </div>
      </div>
      <div AreaDragDrop (files)="onLogoChangeDropped($event)" class="add-image-container">
        <div class="add-image-header">
          {{ 'common.image' | translate }}
          <button  (click)="logoUploader.click()">
            {{ 'store.settings.addImage' | translate }}
          </button>
        </div>
        <div class="img-container">
          <img [src]="(voucher.logoImageUrl !== '' ) ? voucher.logoImageUrl : 'assets/images/image.png'" alt="">
          <div>
            {{ 'store.vouchers.form.dropImage' | translate }}
          </div>
          <div *ngIf="isSubmitted && !voucher.logoImageUrl" class="error">{{ 'store.vouchers.form.logoRequired' | translate }}</div>

        </div>
        <input style="display: none" type="file" #logoUploader accept="image/*" (change)="onLogoChange($event)">

      </div>
    </div>
  </div>
  <div class="redeem-section">
    <div class="redeem-header">
      <div>{{ 'store.vouchers.form.howToRedeem' | translate }}</div>
      <button (click)="onAddStep()">
        <img src="assets/images/add-circle.png" alt="">
        {{ 'store.vouchers.form.addStep' | translate }}
      </button>
    </div>
    <div  *ngFor="let step of voucher?.redems; let i = index; trackBy: trackByFn">
      <div class="step" >
      <div class="num">
        {{i+1}}
      </div>
      <div class="input">
        <input [(ngModel)]="voucher.redems[i]" type="text">
      </div>
      <div (click)="onDeleteStep(i)" class="delete">
        <img src="assets/images/delete.png" alt="">
      </div>

    </div>
    <div *ngIf="isSubmitted && !voucher.redems[i]?.toString()?.trim()" class="error">{{ 'store.vouchers.form.stepRequired' | translate }}</div>
  </div>
  </div>

  <div class="tos">
    <div class="tos-title">
      {{ 'store.vouchers.form.tos' | translate }}
    </div>
    <textarea [(ngModel)]="tos">
    </textarea>
    <div *ngIf="isSubmitted && !this.tos?.toString()?.trim()" class="error">{{ 'store.vouchers.form.tosRequired' | translate }}</div>

  </div>
  <div class="btns-last">
    <button class="cancel" backButton>{{ 'common.cancel' | translate }}</button>
    <button class="save" (click)="SaveVoucher()">{{ (editMode ? 'common.saveChanges' : 'store.vouchers.form.publish') | translate }}</button>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
<ng-template #template>
  <div *ngIf="!redeemDone">

    <div class="modal-header">
      <img src="assets/images/x-modal.svg" (click)="modalRef?.hide()" alt="">
      <h5>{{ 'store.vouchers.generateTitle' | translate }}</h5>
    </div>
    <div class="modal-body">
      <div class="label">{{ 'store.vouchers.quantity' | translate }}</div>
      <div class="input-container">
        <input [(ngModel)]="redeemCode" oninput="validity.valid||(value='');" min="0" type="number" placeholder="100">
        <div *ngIf="invalidCode" style="color: red;font-size: 13px">{{ 'store.vouchers.invalidCode' | translate }}</div>
      </div>
      <button [disabled]="!redeemCode" (click)="generateCode()" class="redeem-btn">{{ 'store.vouchers.generate' | translate }}</button>
    </div>
  </div>
  <div class="redeemed-container" *ngIf="redeemDone">
    <img src="assets/images/success_icon.png">
    <h5>{{ 'store.vouchers.generated' | translate }}</h5>
    <div style="font-size: 13px;
font-weight: 400;
font-style: normal;
color: #262626;
text-align: center;">
      {{ 'store.vouchers.generatedNote' | translate: { count: redeemCode } }}
    </div>
    <button class="done-btn" (click)="onDone()">{{ 'common.done' | translate }}</button>

  </div>
</ng-template>
